export const UserAddIcon = ({
  strokeColor = "var(--color-icon-obscure)",
  ...props
}: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <g id="vuesax/outline/user-add">
      <g id="user-add">
        <path
          id="Vector"
          d="M12 12.75C8.83 12.75 6.25 10.17 6.25 7C6.25 3.83 8.83 1.25 12 1.25C15.17 1.25 17.75 3.83 17.75 7C17.75 10.17 15.17 12.75 12 12.75ZM12 2.75C9.66 2.75 7.75 4.66 7.75 7C7.75 9.34 9.66 11.25 12 11.25C14.34 11.25 16.25 9.34 16.25 7C16.25 4.66 14.34 2.75 12 2.75Z"
          fill={strokeColor}
        />
        <path
          id="Vector_2"
          d="M3.41016 22.75C3.00016 22.75 2.66016 22.41 2.66016 22C2.66016 17.73 6.85015 14.25 12.0002 14.25C13.0102 14.25 14.0001 14.38 14.9601 14.65C15.3601 14.76 15.5902 15.17 15.4802 15.57C15.3702 15.97 14.9601 16.2 14.5602 16.09C13.7402 15.86 12.8802 15.75 12.0002 15.75C7.68015 15.75 4.16016 18.55 4.16016 22C4.16016 22.41 3.82016 22.75 3.41016 22.75Z"
          fill={strokeColor}
        />
        <path
          id="Vector_3"
          d="M18 22.75C16.82 22.75 15.7 22.31 14.83 21.52C14.48 21.22 14.17 20.85 13.93 20.44C13.49 19.72 13.25 18.87 13.25 18C13.25 16.75 13.73 15.58 14.59 14.69C15.49 13.76 16.7 13.25 18 13.25C19.36 13.25 20.65 13.83 21.53 14.83C22.31 15.7 22.75 16.82 22.75 18C22.75 18.38 22.7 18.76 22.6 19.12C22.5 19.57 22.31 20.04 22.05 20.45C21.22 21.87 19.66 22.75 18 22.75ZM18 14.75C17.11 14.75 16.29 15.1 15.67 15.73C15.08 16.34 14.75 17.14 14.75 18C14.75 18.59 14.91 19.17 15.22 19.67C15.38 19.95 15.59 20.2 15.83 20.41C16.43 20.96 17.2 21.26 18 21.26C19.13 21.26 20.2 20.66 20.78 19.69C20.95 19.41 21.08 19.09 21.15 18.78C21.22 18.52 21.25 18.27 21.25 18.01C21.25 17.21 20.95 16.44 20.41 15.84C19.81 15.14 18.93 14.75 18 14.75Z"
          fill={strokeColor}
        />
        <path
          id="Vector_4"
          d="M19.4998 18.7305H16.5098C16.0998 18.7305 15.7598 18.3905 15.7598 17.9805C15.7598 17.5705 16.0998 17.2305 16.5098 17.2305H19.4998C19.9098 17.2305 20.2498 17.5705 20.2498 17.9805C20.2498 18.3905 19.9098 18.7305 19.4998 18.7305Z"
          fill={strokeColor}
        />
        <path
          id="Vector_5"
          d="M18 20.2595C17.59 20.2595 17.25 19.9195 17.25 19.5095V16.5195C17.25 16.1095 17.59 15.7695 18 15.7695C18.41 15.7695 18.75 16.1095 18.75 16.5195V19.5095C18.75 19.9295 18.41 20.2595 18 20.2595Z"
          fill={strokeColor}
        />
      </g>
    </g>
  </svg>
);
